import * as React from 'react';
import { CuratedCard } from './CuratedCard/CuratedCard.old';
import styles from './styles.module.styl';
export var CuratedCards = function (_a) {
    var _b = _a.cards, cards = _b === void 0 ? [] : _b;
    return (React.createElement("div", { className: "".concat(styles.curatedCards, " container") },
        React.createElement("div", null,
            React.createElement("h2", { className: "header-description" }, "Curated content to fully understand our platform")),
        React.createElement("div", null, cards.map(function (category) { return (React.createElement(CuratedCard, { key: category.id, category: category })); }))));
};
